import React, {
  createContext,
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  useMemo,
  useState,
  useCallback,
} from "react";
import {
  PartnerInformationFormFields,
  PartnerInformationFormData,
} from "@app/neva/constant/partnerInformationTypes";

type PartnerInformationProviderProps = {
  children: ReactNode;
};

export interface PartnerInformationController {
  partnerInformationForm: PartnerInformationFormData;
  setPartnerInformationForm: Dispatch<
    SetStateAction<PartnerInformationFormData>
  >;
  resetPartnerInformationForm: () => void;
}

export const initialPartnerInformationForm: PartnerInformationFormData = {
  [PartnerInformationFormFields.FIRST_NAME]: "",
  [PartnerInformationFormFields.LAST_NAME]: "",
  [PartnerInformationFormFields.BIRTH_DATE]: undefined,
  [PartnerInformationFormFields.PHONE_NUMBER]: "",
  [PartnerInformationFormFields.EMAIL]: "",
  [PartnerInformationFormFields.CONSENT]: false,
};

export const Context = createContext<PartnerInformationController>({
  partnerInformationForm: initialPartnerInformationForm,
  setPartnerInformationForm: () => undefined,
  resetPartnerInformationForm: () => undefined,
});

Context.displayName = "PartnerInformationContext";

const PartnerInformationProvider: FC<PartnerInformationProviderProps> = ({
  children,
}) => {
  const [partnerInformationForm, setPartnerInformationForm] =
    useState<PartnerInformationFormData>(initialPartnerInformationForm);

  const resetPartnerInformationForm = useCallback(() => {
    setPartnerInformationForm(initialPartnerInformationForm);
  }, []);

  const value = useMemo(
    () => ({
      partnerInformationForm,
      setPartnerInformationForm,
      resetPartnerInformationForm,
    }),
    [partnerInformationForm, resetPartnerInformationForm]
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export default PartnerInformationProvider;
